<template>
	<div class="logon">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<div>请绑定手机号</div>
			<div></div>
		</div>
		<!--注册框 -->
		<div class="action">
			<van-cell-group>
				<van-field v-model="usertel" clearable placeholder="请输入手机号" label="手机号" />
				<van-field v-model="sms" clearable placeholder="手机验证码" label="验证码">
					<van-button slot="button" size="small" type="primary" :disabled="code" @click="getcode">{{buttonMsg}}</van-button>
				</van-field>
			</van-cell-group>
			<div class="agree">
				<input type="checkbox" class="check_box tui-checkbox" v-model="checked">
				注册即代表您同意<router-link to="_treaty?id=1">《俱百家用户服务协议》</router-link>
			</div>
			<div class="btn">
				<button :disabled="!checked" :class="{disabled:!checked}" @click="msg">点击进行绑定</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				usertel: '',
				sms: '',
				code: false,
				checked: true,
				buttonMsg: '获取验证码',
				iphon: '',
				codes: '',
				wxdata: ''
			}
		},
		methods: {
			msg() {
				var then = this
				var result = localStorage.getItem("wxinformation")
				this.wxdata = JSON.parse(result)
				if (this.usertel == '') {
					this.$toast('请输入手机号');
					return false;
				}
				if (this.sms == '') {
					this.$toast('请输入验证码');
					return false;
				}
				if (this.usertel != this.iphon || this.sms != this.codes) {
					this.$toast('验证码错误');
					return false;
				}
				this.$axios.post(baseUrl + '/mobile/User/wxbind', {
					tel: this.usertel,
					unionid: this.wxdata.unionid,
					nickname: this.wxdata.nickname,
				}).then((res) => {
					if (res.data.code == 1000) {
						localStorage.setItem('Authorization', res.data.data);
						this.$toast("绑定成功");
						then.$router.push({
							path: '/Home'
						})
					} else {
						this.$toast("绑定失败");
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			//获取验证码
			getcode() {
				if (this.usertel === '') {
					this.$toast('请填写手机号');
					return false;
				} else if (this.usertel && (!(/^[1][345789]\d{9}$/).test(this.usertel) || !(/^[1-9]\d*$/).test(this.usertel) ||
						this.usertel.length !== 11)) {
					this.$toast('手机号码不符合规范');
					return false;
				} else {
					this.code = false
				}
				this.$axios.post(baseUrl + '/mobile/User/get_code', {
					tel: this.usertel
				}).then((res) => {
					if (res.data.code == 2001) {
						this.$toast(res.data.msg);
						this.iphon = res.data.data.tel;
						this.codes = res.data.data.code;
						this.buttonMsg = 60;
						this.code = true
						var auth_timer = setInterval(() => {
							this.buttonMsg--;
							if (this.buttonMsg <= 0) {
								this.buttonMsg = '获取验证码'
								this.code = false
								clearInterval(auth_timer)
							}
						}, 1000)
					} else {
						this.$toast(res.data.msg);
					}
				}).catch((err) => {
					console.log(err);
				});
			}
		}
	}
</script>

<style scoped>
	.logon {
		background: #fff;
		height: 100%;
		padding-top: 2rem;
	}

	.logon .image {
		margin: 1.5rem 0;
	}

	.logon .image img {
		width: 100%;
		height: 100%;
	}

	.logon .image img {
		width: 11rem;
	}

	.logon .action {
		width: 90%;
		margin: 2rem auto;
	}

	.logon .action .van-button {
		border-radius: 1rem;
		background: #F1452F;
		border: 0;
		height: 1.5rem;
		line-height: 1.5rem;
		padding: 0 0.7rem;
	}

	.logon .action .van-cell-group {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		height: 7rem;
		box-sizing: border-box;
		text-align: left;
	}

	.logon .action .btn button {
		width: 80%;
		background: #F1452F;
		border: 0;
		border-radius: 1rem;
		color: #fff;
		height: 2rem;
		font-size: 0.9rem;
		margin-top: 1rem;
	}

	.logon .action .agree {
		margin-top: 2.5rem;
		font-size: 0.75rem;
		color: #c8c8c8;
	}

	.logon .action .agree a {
		color: #666;
	}

	.logon .action .agree input {
		margin: 0;
		vertical-align: middle;
	}

	.logon .action .btn .disabled {
		background: #B0B0B0;
	}

	.logon .van-cell:not(:last-child)::after {
		border-bottom: 0;
	}

	.logon .van-field {
		border-bottom: 1px solid #ebedf0;
	}

	.logon .van-hairline--top-bottom::after,
	.van-hairline-unset--top-bottom::after {
		border: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/wxphone/wxphone.vue